import { unset_height, unset_width } from "../size/size";

export default function item() {
  return {
    ...unset_height(),
    ...unset_width()
  };
}
